import * as yup from 'yup';

export const validationSchema = yup.object({
    transactionDate: yup.date().typeError("Must be a valid date").required("Required"),
    shift: yup.string().typeError("Must be a text").required("Required"),
    quantity: yup.number().typeError("Must be a valid number").required("Required"),
    inventoryId: yup.string().typeError("Must be a text").required("Required"),
    pumpNumber: yup.string().required("Required"),
})